<div class="reorder">
  <button
    type="button"
    aria-label="Move up"
    (click)="onReorderButtonClick(reorderAction.Up)"
  >
    <nsp-icon [name]="IconNames.ArrowUp" />
  </button>
  <button
    type="button"
    aria-label="Move down"
    (click)="onReorderButtonClick(reorderAction.Down)"
  >
    <nsp-icon [name]="IconNames.ArrowDown" />
  </button>
</div>
